// Preferências do navegador; tudo em try/catch porque o armazenamento pode estar bloqueado.
function read(store: () => Storage, key: string): string | null {
  try {
    return store().getItem(key);
  } catch {
    return null;
  }
}
function write(store: () => Storage, key: string, value: string | null) {
  try {
    if (value === null) store().removeItem(key);
    else store().setItem(key, value);
  } catch {
    /* sem armazenamento: segue só em memória */
  }
}

const TENANT_KEY = 'alicerce.tenant';
const IMPERSONATE_KEY = 'alicerce.impersonating';

export const prefs = {
  tenantId: () => read(() => localStorage, TENANT_KEY),
  setTenantId: (id: string | null) => write(() => localStorage, TENANT_KEY, id),
  /** Impersonação vale só nesta aba. */
  impersonating: () => read(() => sessionStorage, IMPERSONATE_KEY),
  setImpersonating: (tenantId: string | null) => write(() => sessionStorage, IMPERSONATE_KEY, tenantId),
};

/** Estado da configuração guiada, por pessoa e negócio (cada sócio vê o próprio tour). */
const setupKey = (name: string, userId: string, tenantId: string) => `gestora.setup.${name}.${userId}.${tenantId}`;

export const setupPrefs = {
  /** O tour de boas-vindas já foi visto (concluído ou dispensado). */
  tourSeen: (u: string, t: string) => read(() => localStorage, setupKey('tour', u, t)) === '1',
  setTourSeen: (u: string, t: string) => write(() => localStorage, setupKey('tour', u, t), '1'),
  /** Passos concluídos que já ganharam a mensagem de parabéns. `null` = este navegador ainda não viu nenhum. */
  celebrated: (u: string, t: string): string[] | null => {
    const raw = read(() => localStorage, setupKey('celebrated', u, t));
    if (raw === null) return null;
    try {
      const list: unknown = JSON.parse(raw);
      return Array.isArray(list) ? list.filter((k): k is string => typeof k === 'string') : [];
    } catch {
      return [];
    }
  },
  setCelebrated: (u: string, t: string, keys: string[]) => write(() => localStorage, setupKey('celebrated', u, t), JSON.stringify(keys)),
  /** Passos que a pessoa pulou por agora: vão para o fim da fila do "Próximo passo". */
  skipped: (u: string, t: string): string[] => {
    try {
      const list: unknown = JSON.parse(read(() => localStorage, setupKey('skipped', u, t)) ?? '[]');
      return Array.isArray(list) ? list.filter((k): k is string => typeof k === 'string') : [];
    } catch {
      return [];
    }
  },
  setSkipped: (u: string, t: string, keys: string[]) => write(() => localStorage, setupKey('skipped', u, t), JSON.stringify(keys)),
  /** Barra de progresso recolhida. */
  collapsed: (u: string, t: string) => read(() => localStorage, setupKey('collapsed', u, t)) === '1',
  setCollapsed: (u: string, t: string, v: boolean) => write(() => localStorage, setupKey('collapsed', u, t), v ? '1' : null),
  /** Passo que o guia está acompanhando nesta aba. */
  guiding: () => read(() => sessionStorage, 'gestora.setup.guiding'),
  setGuiding: (key: string | null) => write(() => sessionStorage, 'gestora.setup.guiding', key),
};
